import { ListHttpResponse } from "src/app/_common/models/core.model";
import { ShopModel } from "../shops/shop.model";
import { PrinterTypeEnum } from "./printer.enum";

export interface PrinterModel {
    id: number,
    name: string,
    uniqueNumber: string,
    evidenceNumber: string,
    ip: string,
    port: number | null,
    isActive: boolean,
    shop: ShopModel,
    printerType: string,
    dateFrom: Date,
    oldData?: PrinterOldDataModel
}

export interface PrinterOldDataModel {
    shopId: number,
    name: string,
    ipAddress: string,
    port: number | null
}

export interface PrinterTypeModel {
    id: number,
    printerType: string
}
  
export function newPrinter(): PrinterModel {
    return ({} as any) as PrinterModel;
}

export interface PrinterListResponse extends ListHttpResponse<PrinterModel> { }

export interface PrinterTypeListResponse extends ListHttpResponse<PrinterTypeModel> { }

